import api from './api';

// A web document owns one session; resizing and route remounts must not create deliveries.
const sessionId = `web-ad-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
const options = { timeout: 15000, suppressGlobalError: true };
const interaction = (id, action, placementKey) =>
  api.postPublic(`/ads/${id}/${action}`, { placementKey, sessionId }, options);
export const adsApi = {
  placements: async (locale, signal) => {
    const response = await api.getPublic('/ads/placements', {
      ...options,
      signal,
      params: { locale },
    });
    return response.data.data;
  },
  impression: (id, placementKey) => interaction(id, 'impression', placementKey),
  click: (id, placementKey) => interaction(id, 'click', placementKey),
  report: (id, placementKey, reason) =>
    api.postPublic(`/ads/${id}/report`, { placementKey, reason }, options),
};
